import { useState, useEffect } from "react";
import {Typography, Modal, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import OutlinedButton from '../Button/OutlinedButton/OutlinedButton';

import SectionSpinner from "../Loading/SectionSpinner/SectionSpinner";

import IconQueue from '../../assets/svgs/people-group.svg';

import './QueueModal.css';


const modal_style = {
  position: 'absolute',
  top: '20px',
  left: '50%',
  transform: 'translate(-50%, 0px)',
  width: '60vw',
  bgcolor: 'rgba(255,255,255,0.05)',
  backdropFilter: 'blur(20px)',
  borderRadius: '5px',
  boxShadow: '0px 20px 50px #00000029',
  p: 4,
};


function QueueModal(props) {

    const [open, setOpen] = useState(false);
    
    const [autoupdate, setAutoupdate] = useState();
    
    const [lockForm, setLockForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({message:'', firstName:false, lastName:false, email:false, twitter:false});
    
    const [queue, setQueue] = useState([]);


    function handleOpen(){
        setOpen(true);
        getQueueData();
        console.log("Queue modal open called!");
    }

    function handleClose(){
        // Prevent closing when we are awaiting a reply.
        if(!lockForm){
            setOpen(false);
        }
    }


    function getQueueData(){
        
        var queue_url = process.env.REACT_APP_API_ENDPOINT + 'squadslive/queue';

        return fetch(queue_url, {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(function (data){
    
            if(data.code === 200){
                setQueue(data.data);
                setLoading(false);
                console.log(data.data);
            }else{
                console.log("[LOG] An error occured loading the queue.");
                return false;
            }        
        })
    }

    function removeFromQueue(id, name){

        if (window.confirm("Are you sure you want to remove " + name + " from the queue?") == true) {
        
            console.log("Remove from queue: " + id);

            // Submit the data to the server.
            // Change the submit button to a spinner and lock form inputs
            setLoading(true);
            setLockForm(true);

            return fetch(process.env.REACT_APP_API_ENDPOINT + 'squadslive/complete', {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({id: id+""})
            })
            .then(res => res.json())
            .then(function (response){    
                if(response.code === 200){
                    
                    getQueueData();

                    setLoading(false);
                    setLockForm(false);
                    return true;

                }else{
                    console.log("An error occured processing the data.");
                    alert("There was an error updating the ")
                    setLoading(false);
                    setLockForm(false);
                    return false;
                }        
            })

        }
    }

    useEffect(() => {
        console.log(errors);
    },[errors]);
    

    useEffect(() => {

        if(open){
            setAutoupdate(setInterval(function(){
                    if(open){
                        getQueueData();
                        console.log("Autoupdate called.");
                    }else{
                        // Ignore as we're not open.
                        console.log("Autoupdate ignored.");
                    }
                },5*1000)
            );
        }else{
            console.log("Autoupdate cleared.");
            clearInterval(autoupdate);
        }

     },[open]);

    


    if(props.loadingState){
        return (
            <></>
        )
    }
    else{
        return (
        <div>

            <img src={IconQueue} alt='Queue' id="common-nav-queue" onClick={handleOpen}/>

            <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={modal_style} className="rezzil-shine">
                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{color:"#ffffff", mb:2}}>
                    Current Queue
                </Typography>

                
                <TableContainer>
                    <Table sx={{ minWidth: 650 }}>
                        <TableBody>
                            {queue.map((row) => (
                                <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                <TableCell component="th" scope="row">
                                    {row.id}
                                </TableCell>
                                <TableCell>{row.user.fname} {row.user.sname}</TableCell>
                                <TableCell>

                                <OutlinedButton
                                        text={'- Remove'}
                                        onClick={() => removeFromQueue(row.id, (row.user.fname + " " + row.user.sname)) }
                                        fullWidth
                                    />
                                </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>



                {
                    loading &&
                    <SectionSpinner/>
                }
                

                
            </Box>
            </Modal>
        </div>
        );
    }
    
  }
  

  export default QueueModal;